import { defineFetch } from 'resift';

const makeVerifyNewSubdomain = defineFetch({
  displayName: 'Verify New Subdomain',
  make: () => ({
    request: (input: string) => ({ http }) =>
      http({
        method: 'POST',
        route: '/client/verify-new-subdomain',
        data: { subdomain: input },
      }),
  }),
});

const verifyNewSubdomain = makeVerifyNewSubdomain();

export default verifyNewSubdomain;
